import * as React from 'react';
import { TooltipDesktop, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IEscrowLabelTooltipProps {
  label: React.ReactElement<unknown>;
}

export function EscrowLabelTooltip({ label }: IEscrowLabelTooltipProps) {
  return (
    <TooltipDesktop
      theme="black"
      title={
        <div className={styles['tooltip']}>
          <UIText2 color="text-inverted-default">Подробнее о эскроу–счёте</UIText2>
        </div>
      }
    >
      {label}
    </TooltipDesktop>
  );
}
